//tabs driven by core js.
/* global mzFunc mzTabs */

import React, { useEffect, useState, useRef } from "react";
import PropTypes from 'prop-types';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';
import GTMHelper from '../../../Helpers/gtmHelper';
//import NavHelper from '../../../Helpers/navhelper';

import Button from '../../1_Atoms/Button/Button';
import { Jelly } from '../../2_Molecules/Jelly/Jelly';
import { Modal } from '../../3_Organisms/Modal/Modal';
import { PreOrderModal } from '../../3_Organisms/Modal/PreOrderModal';
import { getLang, getProvince, hideCmsHiddenBlock, updateLanguageLink, getLoading, getApiBaseUrl } from '../../../utils';

export const VehiclePage = ({summaryCalculator = window.summaryCalculator, ...props }) => {
    const [response, setResponse] = useState({ model_years: [], categories: {} });
    const [vehicleLegal, setVehicleLegal] = useState([{ copy: '' }]);
    
    const leftArrowRef = useRef();
    const rightArrowRef = useRef();
    const tabsRef = useRef();
    const tabsContainerRef = useRef();
    const [loading, setLoading] = useState(true);
    const [visibleTab, setVisibleTab] = useState('2158');
    const [visibleLeftArrow, setVisibleLeftArrow] = useState(false);
    const [visibleRightArrow, setVisibleRightArrow] = useState(false);
	const [legalModalOpen, setLegalModalOpen] = React.useState(false);
    const navigate = useNavigate();
    const { t, i18n } = useTranslation(['vehicles', 'general']);

	const gtmHelper = new GTMHelper();
	//const navHelper = new NavHelper();

    summaryCalculator.CurrentStep = 0;

    hideCmsHiddenBlock();

    useEffect(() => {
        async function executeTasks() {
            // This is needed to have the right vehicle landing page for retailers which are per province
            const isRetailerMode = await summaryCalculator.isRetailerMode();

            const requestResponse = await summaryCalculator.loadVehicles();
            const requestLegalResponse = await summaryCalculator.loadVehiclesLegal("JXTN84", "AA00");

            setResponse(requestResponse);
            setVehicleLegal(requestLegalResponse);

            setLoading(false);
            summaryCalculator.reset(true);

			if(typeof mzFunc === 'object' && typeof mzTabs === 'object'){
				mzFunc.waitForEl('.mzBuildandPrice .mz-tabs').then(function(components){mzTabs.init(components);});
			}

            // Rewrite the top navigation to not have the hash in the URL
            if(window.location.hash) {
                const newLocation = window.location.origin + window.location.pathname.replace('/#/', '');
                window.history.pushState({}, document.title, newLocation);
            }
        }

        executeTasks();

        // Used the CMS language change as this page doesn't include the NAV bar
        updateLanguageLink();
    }, []);

    const Cats = Object.keys(response.categories).map((item, key) => {
        return (
            <a
                onClick={() => {
					setVisibleTab(response.categories[item].id);
					gtmHelper.setGTM({'action':'Tab Click','vehicle tab': response.categories[item].title}, true, false);
				}}
                key={response.categories[item].id}
				className={visibleTab === response.categories[item].id ? "mz-tabs-tab interactive active" : "mz-tabs-tab interactive"}
			>
                {response.categories[item].title}
            </a>
        )
    })

    const PreviusModel = response.model_years.filter(item => item.previous_model === true);

    if (PreviusModel.length) {
        const previusModelTab = <a
            onClick={() => {
				setVisibleTab('previus_model')
				gtmHelper.setGTM({'action':'Tab Click', 'vehicle tab': 'Previous Model'}, true , false);
			}}
            key='previus_model'
            className={visibleTab === 'previus_model' ? "mz-tabs-tab interactive active" : "mz-tabs-tab interactive"}
        >
            {getLang() ==='en' ? 'Previous Models' : 'MODÈLES PRÉCÉDENTS'}
        </a>;

        Cats.push(previusModelTab);
    }

    const Model = response.model_years.map((item, key) => {
        const stripedHtml = item.description.replace(/(<([^>]+)>)/gi, "");
        const CategoryNumb = item.carline.categories.map((cat, key) => {

            if (cat.id === visibleTab && item.previous_model === false) {
                return cat.id
            } if (visibleTab === 'previus_model' && item.previous_model === true) {
                return 'previus_model'
            } else {
                return null
            }
        })

		const setTopLabel = ()=>{
			let topLabel= item.is_coming_soon ? item.coming_soon_data.top_copy : null;
			topLabel=item.top_copy ? item.top_copy : topLabel;

			return topLabel;
		}

		const carCont = getLang() ==='en' ?  `${item.year.title} ${item.carline.title}` : `${item.carline.title} ${item.year.title}`;

        return (
            <div key={key} className="mz-tabs__list" style={CategoryNumb.includes(visibleTab) ? {} : { display: 'none' }}>
                <Jelly
                    topLabel={setTopLabel()}
                    carName={visibleTab === 'previus_model' ? carCont : item.carline.title}
                    carModel={stripedHtml}
                    carFeatures={item.highlighted_features}
                    carPrice={item.financial.msrp}
                    btnLabel="Design yours"
                    isComingSoon={item.is_coming_soon}
                    onClick={() => {
                        if(!item.is_coming_soon){
                            const urlParams = new URLSearchParams(window.location.search);
                            urlParams.set('prov_code', getProvince());
                            urlParams.set('lang_code', getLang());
                            //summaryCalculator.SelectedModelYear = item;
                            window.providerCalls = 0;
                            handleModelClick(`/${item.year.url_slug}/${item.carline.url_slug}/?${decodeURI(urlParams)}`);
                            gtmHelper.setGTM({'action':'Vehicle Click', 'model': item.carline.url_slug, 'year': item.year.url_slug}, true , false);
                        }
					}}
					onMouseOver={(e) => handleModelOver(e)}
					onMouseOut={(e) => handleModelOut(e)}
                    carImg={`${item.visual.static_content_base_path}${item.visual.jelly_path}${item.visual.jelly}`}
                    carImgHover={`${item.visual.static_content_base_path}${item.visual.jelly_path}${item.visual.jelly_hover}`}
                />
            </div>
        )
    })

    const handleModelClick = navigateUrl => {
        window.ocaRetry = 0
        window.providerRetry = 0

        // PATCH ADDED FOR Having twice dealerID in URL and causing some session storage switch issue
        const currentLocation = window.location;
        const currentUrl = currentLocation.origin + currentLocation.pathname + currentLocation.hash;
        const urlWithoutQueryParams = currentUrl.split('?')[0];
        window.history.replaceState(null, 'React App', urlWithoutQueryParams);

        navigate(navigateUrl)
    };
	const handleModelOver =  (e) => {
		const jellyContent = e.target.closest('.mz-tabs__content');
		const jellySibArr = jellyContent.querySelectorAll('.mz-jelly')
			jellySibArr.forEach(jellySib =>{
				if(e.target !== jellySib){
				if(!jellySib.classList.contains('active') && jellySib.classList.contains('mz-jelly')){
					jellySib.classList.add('fade');
				}
			}
		});
    };
	const handleModelOut =  (e) => {
		const jellyContent = e.target.closest('.mz-tabs__content');
		const jellySibArr = jellyContent.querySelectorAll('.mz-jelly')
			jellySibArr.forEach(jellySib =>{
				if(e.target !== jellySib){
				if(!jellySib.classList.contains('active') && jellySib.classList.contains('mz-jelly')){
					jellySib.classList.remove('fade');
				}
			}
		});
	};

    if (loading) {
        return (
            <div className="mz-spinner">{t("loading")}</div>
        )
    }


    const HasFinancialProviderError = JSON.parse(sessionStorage.getItem(Constants.HasFinancialProviderError));

    return (
        <>
        {getLoading(loading, t)}
        <div className="wrapper">
            <div className="mz-vehicles mz-container">
                {HasFinancialProviderError ? <h3 class="error">{t("general:service_error")}</h3>: ''}
                <h2>{t("app_title")}</h2>
                <h5>{t("select_a_model")}</h5>
                <div className="mz-tabs" ref={tabsContainerRef}>
					<div className="mz-tabs-menu">
						<div className="mz-tabs-menu-container">
						   <div className="mz-tabs-menu-inner">
                            	{Cats}
							</div>
						</div>
						<div className="mz-tabs-menu--left"><i className="mz-svg mz-svg--grey mz-svg-chevroncarousel mz-svg--rotate180"></i></div>
						<div className="mz-tabs-menu--right active"><i className="mz-svg mz-svg--grey mz-svg-chevroncarousel"></i></div>
                    </div>
                    <div className="mz-tabs__content">
                        {Model}
                    </div>
                </div>
				<div className="mz-legal">
	                <Button
	                    className="mz-btn mz-btn--legal text--grey"
	                    label={t("general:legal")}
	                    backgroundColor="grey"
                        colour="grey"
	                    icon={true}
	                    iconAfter={true}
	                    svg_className=""
	                    svg_list="plus"
	                    size={0.6}
	                    onClick={() => {
							document.querySelector('body').classList.add('disabled');
							setLegalModalOpen(true);
							gtmHelper.setGTM({'action':'Open Modal','modal': 'legal'}, true, false);
						}}
	                />
	            </div>
				<Modal modalContent={vehicleLegal[0].copy} isOpen={legalModalOpen} handleClose={setLegalModalOpen} modalId='legalModal' />
            </div>
        </div>
    </>
    )
};

VehiclePage.propTypes = {
    ApiUrl: PropTypes.string,
}

VehiclePage.defaultProps = {
    ApiUrl: `${getApiBaseUrl()}/api/ModelYears?prov_code=${getProvince()}&lang_code=${getLang()}`,
}
